import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { ExpandablePanel, TimeFormVerdict } from '@swf/sports/components';
import { notEmpty } from '@swf/sports/utils/notEmpty';

import { useSportsRacePageWidget } from '../../model';

import styles from './TimeFormDropdown.scss';
import TimeFormRunner from './components/Runner/Runner';
import Title from './components/Title/Title';

const TimeFormDropdown: React.FC = () => {
  const { widgetSelect } = useSportsRacePageWidget();
  const currentRace = useSelector(widgetSelect.currentRace);
  const timeformRunners = useSelector(widgetSelect.timeformRunners);
  const raceWinMarket = useSelector(widgetSelect.raceWinMarket);
  const locale = useSelector(select.locale.get);
  const [open, setOpen] = useState(false);

  const marketViewRunners = timeformRunners
    ?.map((id) => raceWinMarket?.runners.find(({ selectionId }) => selectionId === Number(id)))
    .filter(notEmpty);

  if (
    !(currentRace?.verdict && locale.startsWith('en')) &&
    !(raceWinMarket && marketViewRunners?.length)
  )
    return null;

  return (
    <div className={styles.container}>
      <ExpandablePanel
        openInitially={false}
        onToggle={() => setOpen(!open)}
        title={
          <Title isOpen={open}>
            <TimeFormVerdict />
          </Title>
        }
      >
        {currentRace?.verdict && locale.startsWith('en') ? (
          <p className={styles.verdict}>{currentRace.verdict}</p>
        ) : null}

        {raceWinMarket && marketViewRunners?.length ? (
          <ul className={styles.timeFormRunners}>
            {marketViewRunners.map((runner) => (
              <TimeFormRunner key={runner.selectionId} runner={runner} market={raceWinMarket} />
            ))}
          </ul>
        ) : null}
      </ExpandablePanel>
    </div>
  );
};

export default TimeFormDropdown;
